import { createFetchTimeout } from "@mgdx/api/lib/createFetchTimeout";
import { Configuration, LinkedPatientApi } from "@mgdx/api/lib/patient/patient";
import requestHeaders from "@mgdx/api/lib/requestHeaders";
import { getAccessToken } from "@mgdx-libs/firebase";

// memo: Cookieの利用のため、pathをyqbに変更
export const linkedPatientWithCookieApi = new LinkedPatientApi(
  new Configuration({
    basePath: process.env.MGDX_YQB_URL + "/api-patient",
    credentials: "include",
    accessToken: getAccessToken,
    headers: { ...requestHeaders, ...(process.env.MGDX_API_KEY && { "X-MGDX-API-KEY": process.env.MGDX_API_KEY }) },
    fetchApi: createFetchTimeout(60000, "linkedPatientWithCookieApi"),
  })
);
